import React, { useReducer } from "react"
import UserProfileModel from "../models/user-models/UserProfileModel";
import { useParams } from "react-router-dom";
import { SUBSCRIPTION_STATE } from "../models/insurance-models/PolicySubscriptionState";
import PolicyManagementRenewalApi from '../api/policmanagement.renewal.api';
import { EventEmitterService, EventKey } from "../services/EventEmitterService";
import { Action } from "../models/Action";
import { awaitWithLoading } from "../services/utils";

const defaultState = {
    dispatch: (action) => {},
    insuranceSubscriptionState: SUBSCRIPTION_STATE.CURRENT,
    renewalOffers: [],
}

export const RENEWAL_ACTIONS = {
    TOGGLE_SUBS_STATE: 'TOGGLE_SUBS_STATE',
    LOAD_RENEWAL_OFFERS: 'LOAD_RENEWAL_OFFERS',
}

const reducer = (state, action) => {
    let newState = state
    switch (action.type) {
        case RENEWAL_ACTIONS.TOGGLE_SUBS_STATE:
            newState = {...state, insuranceSubscriptionState: state.insuranceSubscriptionState == SUBSCRIPTION_STATE.CURRENT
                 ? SUBSCRIPTION_STATE.RENEWAL : SUBSCRIPTION_STATE.CURRENT}
            break
        case RENEWAL_ACTIONS.LOAD_RENEWAL_OFFERS:
            return {...state, renewalOffers: action.data}
      default: 
        newState = state;
        break
    }

    return newState
};


export const PolicyRenewalContextStore = React.createContext(defaultState)

const PolicyRenewalContext = (props) => {
    const [state, dispatch] = useReducer(reducer, defaultState);
    const insuranceId = props.insuranceId

    const loadSubscriptionRenewal = async () => {
        let res = await PolicyManagementRenewalApi.getSubscriptionRenewalOffers(insuranceId)
        if(res.ok) {
            dispatch(new Action(RENEWAL_ACTIONS.LOAD_RENEWAL_OFFERS, res.parsedData))
        }
        else {
            EventEmitterService.dispatch(EventKey.ShowError, res)
        }
    }

    React.useEffect(() => {
        loadSubscriptionRenewal()

        let id = EventEmitterService.subscribe(EventKey.LIABILITY_EXTENSION_OFFER_SUCCESS, () => {
            loadSubscriptionRenewal()
        })

        let id3 = EventEmitterService.subscribe(EventKey.PHYSICAL_EXTENSION_PURCHASE_SUCCESS, () => {
            loadSubscriptionRenewal()
        })

        let id2 = EventEmitterService.subscribe(EventKey.REFRESH_RENEWAL_OFFERS, () => {
            awaitWithLoading(loadSubscriptionRenewal())
        })

        return function cleanup () {
            EventEmitterService.unsubscribe(EventKey.LIABILITY_EXTENSION_OFFER_SUCCESS, id)
            EventEmitterService.unsubscribe(EventKey.REFRESH_RENEWAL_OFFERS, id2)
            EventEmitterService.unsubscribe(EventKey.PHYSICAL_EXTENSION_OFFER_SUCCESS, id3)
        }
    }, [])

    return (<PolicyRenewalContextStore.Provider value={{ ...state, dispatch}}>
            {props.children}
        </PolicyRenewalContextStore.Provider>)   
}

export default PolicyRenewalContext



